<template>
  <div>
    <el-card>
      <detail-form :mrpFabricPlanCode="params.code" />
      <div class="side-frame-danger group-title">
        {{ $l('tips_title_fabric_plan_detail') || '面料计划明细' }}
      </div>
      <detail-table :mrpFabricPlanCode="params.code" />
    </el-card>
  </div>
</template>
<script>
import DetailForm from '../components/detail-form/index.vue'
import DetailTable from '../components/detail-table/index.vue'
export default {
  name: 'plan-planFabric-detail',
  components: {
    DetailForm,
    DetailTable,
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    // 是否禁用表单
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
  },
}
</script>
